
export enum TaxFilingStatus {
  Single = 1,
  MarriedFilingJointly,
  // MarriedFilingSeparately, // Unsupported
  // HeadOfHousehold,         // Unsupported
  // QualifyingWidower        // Unsupported
}

export class TaxInput {
  filingStatus: TaxFilingStatus
  taxYear: number
  livedWithSpouse: boolean     // This is not currently used
  numberOfFilersOver65: number
  numberOfQualifiedChildDependents: number
  numberOfQualifiedOtherDependents: number
  income: {
    wagesSalariesTips: number
    taxExemptInterest: number
    taxableInterest: number
    qualifiedDividends: number
    unqualifiedDividends: number
    ordinaryDividends: number
    totalIraDistributions: number
    taxableIraDistributions: number
    totalPensionsAndAnnuities: number
    nonTaxablePensionAndAnnuities: number
    taxablePensionAndAnnuities: number
    totalSocialSecurityBenefits: number
    capitalGainOrLoss: number
    qualifiedCapitalGains: number
    unqualifiedCapitalGains: number
    otherIncome: number
    otherIncomeForNiit: number
    adjustmentsToIncome: number
  }
  itemizedDeductionsIn: number
  additionalDeductions: {
    autoLoanInterest: number
    charitableContributions: number
    overtimeIncome: number
    tipIncome: number
  }
  otherQualifyingDeductionsToTaxableIncome: number
  additionalTax: number
  childTaxCreditOrCreditForOtherDependents: number
  additionalCreditsAndPayments: number
  otherTaxes: number
  federalIncomeTaxWithheld: number
  earnedIncomeCredit: number
  refundableAdditionalChildTaxCredits: number
  otherPaymentsAndRefundableCredits: number
  // previouslyPostponedIRAdistributionTaxes: number
  socialSecurityTaxWithheld: number
  medicareTaxWithheld: number
  stateIncomeTaxWithheld: number
  localIncomeTaxWithheld: number
  inflationRate: number
  stateTaxState: string
  stateTaxRate: number

  constructor() {
    this.filingStatus = TaxFilingStatus.Single
    this.taxYear = 0
    this.livedWithSpouse = true     // This is not currently used
    this.numberOfFilersOver65 = 0
    this.numberOfQualifiedChildDependents = 0
    this.numberOfQualifiedOtherDependents = 0
    this.income = {
      wagesSalariesTips: 0,
      taxExemptInterest: 0,
      taxableInterest: 0,
      qualifiedDividends: 0,
      unqualifiedDividends: 0,
      ordinaryDividends: 0,
      totalIraDistributions: 0,
      taxableIraDistributions: 0,
      totalPensionsAndAnnuities: 0,
      nonTaxablePensionAndAnnuities: 0,
      taxablePensionAndAnnuities: 0,
      totalSocialSecurityBenefits: 0,
      capitalGainOrLoss: 0,
      qualifiedCapitalGains: 0,
      unqualifiedCapitalGains: 0,
      otherIncome: 0,
      otherIncomeForNiit: 0,
      adjustmentsToIncome: 0
    }
    this.itemizedDeductionsIn = 0
    this.additionalDeductions = {
      autoLoanInterest: 0,
      charitableContributions: 0,
      overtimeIncome: 0,
      tipIncome: 0,
    }
    this.otherQualifyingDeductionsToTaxableIncome = 0
    this.additionalTax = 0
    this.childTaxCreditOrCreditForOtherDependents = 0
    this.additionalCreditsAndPayments = 0
    this.otherTaxes = 0
    this.federalIncomeTaxWithheld = 0
    this.earnedIncomeCredit = 0
    this.refundableAdditionalChildTaxCredits = 0
    this.otherPaymentsAndRefundableCredits = 0
    // this.previouslyPostponedIRAdistributionTaxes = 0
    this.socialSecurityTaxWithheld = 0
    this.medicareTaxWithheld = 0
    this.stateIncomeTaxWithheld = 0
    this.localIncomeTaxWithheld = 0
    this.inflationRate = 0
    this.stateTaxState = ""
    this.stateTaxRate = 0
  }
}

export class TaxEstimate {
  taxableSocialSecurityBenefits: number
  totalIncome: number
  adjustedGrossIncome: number
  standardDeduction: number
  itemizedDeductions: number
  additionalDeductions: {
    autoLoanInterest: number
    charitableContributions: number
    overtimeIncome: number
    senior: number
    tipIncome: number
  }
  taxBracket: number
  taxableIncome: number
  taxLiability: number
  // childTaxCreditOrCreditForOtherDependents: number
  totalTax: number
  // refundableAdditionalChildTaxCredits: number
  totalOtherPaymentsAndRefundableCredits: number
  totalPayments: number
  amountOwed: number
  amountOverpaid: number
  effectiveTaxRate: number
  effectiveTotalTaxRate: number
  // postponedIRAdistributionTaxes: number
  totalOtherTaxWithholding: number
  stateTaxAmount: number
  stateTaxDue: number
  netInvestmentIncome: number
  niitTax: number
  totalEstimatedTax: number

  constructor() {
    this.taxableSocialSecurityBenefits = 0
    this.totalIncome = 0
    this.adjustedGrossIncome = 0
    this.standardDeduction = 0
    this.itemizedDeductions = 0
    this.additionalDeductions = {
      autoLoanInterest: 0,
      charitableContributions: 0,
      overtimeIncome: 0,
      senior: 0,
      tipIncome: 0,
    }
    this.taxBracket = 0
    this.taxableIncome = 0
    this.taxLiability = 0
    // this.childTaxCreditOrCreditForOtherDependents = 0
    this.totalTax = 0
    // this.refundableAdditionalChildTaxCredits = 0
    this.totalOtherPaymentsAndRefundableCredits = 0
    this.totalPayments = 0
    this.amountOwed = 0
    this.amountOverpaid = 0
    this.effectiveTaxRate = 0
    this.effectiveTotalTaxRate = 0
    // this.postponedIRAdistributionTaxes = 0
    this.totalOtherTaxWithholding = 0
    this.stateTaxAmount = 0
    this.stateTaxDue = 0
    this.netInvestmentIncome = 0
    this.niitTax = 0
    this.totalEstimatedTax = 0
  }
}

export const AdditionalDeductionRules = {
  autoLoanInterest: {start: 2025, end: 2028, singleLimit: 10000, jointLimit: 10000, singleAGIPhaseoutThreshold: 100000, jointAGIPhaseoutThreshold: 200000, phaseoutRate: 200},
  charitableDeduction: {start: 2025, end: undefined, singleLimit: 1000, jointLimit: 2000},
  overtimeIncome: {start: 2025, end: 2028, singleLimit: 12500, jointLimit: 25000, singleAGIPhaseoutThreshold: 150000, jointAGIPhaseoutThreshold: 300000, phaseoutRate: 100},
  enhancedSenior: {start: 2026, end: 2028, singleLimit: 6000, jointLimit: 12000, singleAGIPhaseoutThreshold: 75000, jointAGIPhaseoutThreshold: 150000, phaseoutRate: 0.06},
  tipIncome: {start: 2025, end: 2028, singleLimit: 25000, jointLimit: 25000, singleAGIPhaseoutThreshold: 150000, jointAGIPhaseoutThreshold: 300000, phaseoutRate: 100},
}

export const NiitRules = {
  rate: 0.038,
  singleThreshold: 200000,
  jointThreshold: 250000,
}

export class TaxEstimator {
  estimateTax = (input: TaxInput) => {
    // console.debug(`estimateTax input`, input)
    let estimate = new TaxEstimate()

    estimate.taxableSocialSecurityBenefits = this.computeTaxableSocialSecurityBenefits(input)

    estimate.totalIncome = input.income.wagesSalariesTips + input.income.taxableInterest +
      input.income.taxableIraDistributions + input.income.ordinaryDividends + input.income.taxablePensionAndAnnuities +
      estimate.taxableSocialSecurityBenefits + input.income.qualifiedCapitalGains + input.income.unqualifiedCapitalGains +
      input.income.otherIncome

    estimate.adjustedGrossIncome = estimate.totalIncome - Math.abs(input.income.adjustmentsToIncome)

    if (estimate.adjustedGrossIncome > 0) {
      let standardDeduction = this.getStandardDeduction(input)

      if (input.itemizedDeductionsIn > standardDeduction) {
        estimate.itemizedDeductions = input.itemizedDeductionsIn
        estimate.taxableIncome = estimate.adjustedGrossIncome - input.itemizedDeductionsIn
      } else {
        estimate.standardDeduction = standardDeduction
        estimate.taxableIncome = estimate.adjustedGrossIncome - standardDeduction
      }

      estimate.taxableIncome -= input.otherQualifyingDeductionsToTaxableIncome

      // Handle temporary OBBBA deductions
      // Enhanced senior deduction
      if (input.taxYear >= AdditionalDeductionRules.enhancedSenior.start &&
          input.taxYear <= AdditionalDeductionRules.enhancedSenior.end &&
          input.numberOfFilersOver65 > 0) {
        const seniorRules = AdditionalDeductionRules.enhancedSenior
        let seniorDeduction = 0
        let phaseout = 0
        const threshold = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? seniorRules.jointAGIPhaseoutThreshold : seniorRules.singleAGIPhaseoutThreshold
        seniorDeduction = (input.numberOfFilersOver65 === 1) ? seniorRules.singleLimit : seniorRules.jointLimit
        if (estimate.adjustedGrossIncome > threshold) {
          phaseout = (estimate.adjustedGrossIncome - threshold) * seniorRules.phaseoutRate * input.numberOfFilersOver65
        }
        estimate.additionalDeductions.senior = Math.max(0, seniorDeduction - phaseout)
      }

      // Auto loan interest deduction
      if (input.taxYear <= AdditionalDeductionRules.autoLoanInterest.end &&
          input.additionalDeductions.autoLoanInterest > 0) {
        const autoLoanInterestRule = AdditionalDeductionRules.autoLoanInterest
        let maxDeduction = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? autoLoanInterestRule.jointLimit : autoLoanInterestRule.singleLimit
        const threshold = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? autoLoanInterestRule.jointAGIPhaseoutThreshold : autoLoanInterestRule.singleAGIPhaseoutThreshold
        let phaseout = 0
        if (estimate.adjustedGrossIncome > threshold) {
          phaseout = Math.ceil((estimate.adjustedGrossIncome - threshold) / 1000) * autoLoanInterestRule.phaseoutRate
        }
        estimate.additionalDeductions.autoLoanInterest = Math.max(0, Math.min(maxDeduction - phaseout, input.additionalDeductions.autoLoanInterest))
      }

      // Charitable contributions deduction
      if (!input.itemizedDeductionsIn && input.additionalDeductions.charitableContributions > 0) {
        const charitableRule = AdditionalDeductionRules.charitableDeduction
        const maxDeduction = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? charitableRule.jointLimit : charitableRule.singleLimit
        estimate.additionalDeductions.charitableContributions = Math.min(maxDeduction, input.additionalDeductions.charitableContributions)
      }

      // Overtime income deduction
      if (input.taxYear <= AdditionalDeductionRules.overtimeIncome.end &&
          input.additionalDeductions.overtimeIncome > 0) {
        const overtimeIncomeRule = AdditionalDeductionRules.overtimeIncome
        let maxDeduction = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? overtimeIncomeRule.jointLimit : overtimeIncomeRule.singleLimit
        const threshold = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? overtimeIncomeRule.jointAGIPhaseoutThreshold : overtimeIncomeRule.singleAGIPhaseoutThreshold
        let phaseout = 0
        if (estimate.adjustedGrossIncome > threshold) {
          phaseout = Math.ceil((estimate.adjustedGrossIncome - threshold) / 1000) * overtimeIncomeRule.phaseoutRate
        }
        estimate.additionalDeductions.overtimeIncome = Math.max(0, Math.min(maxDeduction - phaseout, input.additionalDeductions.overtimeIncome))
      }

      // Tip income deduction
      if (input.taxYear <= AdditionalDeductionRules.tipIncome.end &&
          input.additionalDeductions.tipIncome > 0) {
        const tipIncomeRule = AdditionalDeductionRules.tipIncome
        let maxDeduction = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? tipIncomeRule.jointLimit : tipIncomeRule.singleLimit
        const threshold = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? tipIncomeRule.jointAGIPhaseoutThreshold : tipIncomeRule.singleAGIPhaseoutThreshold
        let phaseout = 0
        if (estimate.adjustedGrossIncome > threshold) {
          phaseout = Math.ceil((estimate.adjustedGrossIncome - threshold) / 1000) * tipIncomeRule.phaseoutRate
        }
        estimate.additionalDeductions.tipIncome = Math.max(0, Math.min(maxDeduction - phaseout, input.additionalDeductions.tipIncome))
      }

      estimate.taxableIncome -= estimate.additionalDeductions.senior + estimate.additionalDeductions.autoLoanInterest + estimate.additionalDeductions.charitableContributions + estimate.additionalDeductions.overtimeIncome + estimate.additionalDeductions.tipIncome
      if (estimate.taxableIncome < 0) {
        estimate.taxableIncome = 0
      }

      const taxBracketRecord = this.getTaxBracket(input, estimate.taxableIncome)
      estimate.taxBracket = taxBracketRecord ? taxBracketRecord.bracket : 0

      estimate.taxLiability = this.computeTaxLiability(input, estimate, taxBracketRecord)

      // Calculate state income tax, if applicable
      if (input.stateTaxState && input.stateTaxRate > 0) {
        estimate.stateTaxAmount = Math.round(estimate.adjustedGrossIncome * input.stateTaxRate)
        estimate.stateTaxDue = estimate.stateTaxAmount - input.stateIncomeTaxWithheld
      } else {
        estimate.stateTaxAmount = input.stateIncomeTaxWithheld
        estimate.stateTaxDue = 0
      }

      // estimate.childTaxCreditOrCreditForOtherDependents = this.computeDependentTaxCredit(input, estimate)

      this.computeNiit(input, estimate)

      estimate.totalTax = estimate.taxLiability + input.additionalTax -
        input.childTaxCreditOrCreditForOtherDependents - input.additionalCreditsAndPayments +
        input.otherTaxes + estimate.niitTax
      //  + input.previouslyPostponedIRAdistributionTaxes
    }

    // estimate.refundableAdditionalChildTaxCredits = this.computeAdditionalChildTaxCredit(input, estimate)

    estimate.totalPayments = input.federalIncomeTaxWithheld + input.earnedIncomeCredit
      + input.refundableAdditionalChildTaxCredits + input.otherPaymentsAndRefundableCredits

    // Non Federal Taxes are simply added to the total.
    estimate.totalOtherTaxWithholding = input.socialSecurityTaxWithheld + input.medicareTaxWithheld
      + input.localIncomeTaxWithheld

    estimate.totalEstimatedTax = estimate.totalTax + estimate.stateTaxAmount + estimate.totalOtherTaxWithholding

    if (estimate.adjustedGrossIncome > 0) {
      estimate.effectiveTotalTaxRate = estimate.totalEstimatedTax / estimate.adjustedGrossIncome
    }

    // Concerning Federal taxes only.
    if (estimate.adjustedGrossIncome > 0) {
      estimate.effectiveTaxRate = estimate.totalTax / estimate.adjustedGrossIncome
    }
    if (estimate.totalTax > estimate.totalPayments) {
      estimate.amountOwed = estimate.totalTax - estimate.totalPayments
    } else {
      estimate.amountOverpaid = estimate.totalPayments - estimate.totalTax
    }

    return estimate
  }

  computeTaxableSocialSecurityBenefits(input: TaxInput) {
    // NOTE: line numbers refer to Social Security Benefits Worksheet
    // https://www.irs.gov/pub/irs-pdf/i1040gi.pdf (page 31)
    const line = new Array(19).fill(0)

    line[1] = input.income.totalSocialSecurityBenefits
    if (line[1] === 0) {
      return 0
    }

    line[2] = Math.round(line[1] * 0.5)

    line[3] = input.income.wagesSalariesTips + input.income.taxableInterest +
      input.income.ordinaryDividends +
      input.income.taxableIraDistributions + input.income.taxablePensionAndAnnuities +
      input.income.qualifiedCapitalGains + input.income.unqualifiedCapitalGains +
      input.income.otherIncome

    line[4] = input.income.taxExemptInterest
    line[5] = line[2] + line[3] + line[4]
    line[6] = input.income.adjustmentsToIncome

    // TODO: Check on applicability of the Social security Benefits Worksheet line 6-7
    // which isn't handled in the Simplified 1040 Tax Calculator

    if (line[6] > line[5]) {
      return 0
    }

    line[7] = line[5] - line[6]

    line[8] = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? 32000 : 25000
    // NOTE: Ignoring living with spouse for Married filing separately

    if (line[8] > line[7]) {
      return 0
    } else {
      line[9] = Math.max(line[7] - line[8], 0)
    }

    line[10] = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? 12000 : 9000
    line[11] = (line[9] > line[10]) ? line[9] - line[10] : 0
    line[12] = Math.min(line[9], line[10])
    line[13] = Math.round(line[12] / 2)
    line[14] = Math.min(line[2], line[13])
    line[15] = Math.round(line[11] * 0.85)
    line[16] = line[14] + line[15]
    line[17] = Math.round(line[1] * 0.85)
    line[18] = Math.min(line[16], line[17])

    return line[18]
  }

  futureValue(presentValue: number, infRate: number, periods: number): number {
    if (infRate === 0 || periods === 0) {
      return presentValue
    } else {
      const futureValue = presentValue * Math.pow(1.0 + infRate, periods)
      // return roundMoney(futureValue)
      return Math.round(futureValue)
    }
  }

  getStandardDeduction(input: TaxInput): number {
    let deduction = 0

    const taxYear = this.getEffectiveTaxYear(input)
    const infYears = input.taxYear - taxYear
    const infRate = input.inflationRate ?? 0

    const record = StandardDeductionTable.find(r => input.filingStatus === r.filingStatus && taxYear === r.taxYear)
    if (record) {
      deduction = this.futureValue(record.baseDeduction, infRate, infYears)
      if (input.numberOfFilersOver65 > 0) {
        deduction += this.futureValue(record.over65Deduction, infRate, infYears) * input.numberOfFilersOver65
      }
    }

    return deduction
  }

  getTaxBracket(input: TaxInput, agi: number) {
    const effYear = this.getEffectiveTaxYear(input)
    const filingStatus = input.filingStatus
    const infYears = input.taxYear - effYear
    const infRate = input.inflationRate

    let infRecord: ITaxBracketRecord | undefined = undefined
    let index = 0
    do {
      const record = TaxBracketTable[index]
      if (effYear === record.taxYear && filingStatus === record.filingStatus) {
        let start: number
        let end: number | null = null
        if (infYears > 0 && infRate > 0) {
          start = this.futureValue(record.start, infRate, infYears)
          end = record.end ? this.futureValue(record.end, infRate, infYears) : null
        } else {
          start = record.start
          end = record.end
        }
        if (agi >= start && (end === null || agi <= end)) {
          infRecord = {
            taxYear: input.taxYear,
            filingStatus: record.filingStatus,
            start: start,
            end: end,
            bracket: record.bracket,
            baseTax: this.futureValue(record.baseTax, infRate, infYears)
          }
        }
      }
      ++index
    } while (!infRecord && index < TaxBracketTable.length)

    return infRecord
  }

  getTaxBrackets(taxYear: number, filingStatus: TaxFilingStatus, infRate: number = 0) : ITaxBracketRecord[] {
    const year = Math.max(Math.min(taxYear, MaxTaxYear), MinTaxYear)
    const records = TaxBracketTable.filter(r =>
      year === r.taxYear && filingStatus === r.filingStatus)

    const infYears = taxYear - year
    if (infRate > 0 && infYears > 0) {
      const infRecords = new Array<ITaxBracketRecord>(records.length)
      for (let ii = 0; ii < records.length; ii++) {
        const rec = records[ii]
        infRecords[ii] = {
          taxYear: taxYear,
          filingStatus: rec.filingStatus,
          start: this.futureValue(rec.start, infRate, infYears),
          end: rec.end ? this.futureValue(rec.end, infRate, infYears) : null,
          bracket: rec.bracket,
          baseTax: this.futureValue(rec.baseTax, infRate, infYears)
        }
      }
      return infRecords
    }

    return records
  }

  // This an alternate way of inflating the brackets, but it doesn't seem to make any significant difference over the old version
  // getTaxBrackets(taxYear: number, filingStatus: TaxFilingStatus, infRate: number = 0) : ITaxBracketRecord[] {
  //   const year = Math.max(Math.min(taxYear, MaxTaxYear), MinTaxYear)
  //   const records = TaxBracketTable.filter(r =>
  //     year === r.taxYear && filingStatus === r.filingStatus)
  //
  //   const infYears = taxYear - year
  //   if (infRate > 0 && infYears > 0) {
  //     const infRecords = new Array<ITaxBracketRecord>(records.length)
  //     let baseTax = 0
  //     for (let ii = 0; ii < records.length; ii++) {
  //       const rec = records[ii]
  //       const start = this.futureValue(rec.start, infRate, infYears)
  //       const end = rec.end ? this.futureValue(rec.end, infRate, infYears) : null
  //       infRecords[ii] = {
  //         taxYear: taxYear,
  //         filingStatus: rec.filingStatus,
  //         start: start,
  //         end: end,
  //         bracket: rec.bracket,
  //         baseTax: baseTax
  //       }
  //       if (!end) {
  //         baseTax = 0
  //       } else {
  //         baseTax = (end - start) * rec.bracket + baseTax
  //       }
  //     }
  //     return infRecords
  //   }
  //
  //   return records
  // }

  getMedicarePremium(taxYear: number, filingStatus: TaxFilingStatus, agi: number, infRate: number = 0) {
    const year = Math.max(Math.min(taxYear, MaxMedicareYear), MinMedicareYear)

    const record = MedicarePremiumTable.find(r =>
      year === r.year && filingStatus === r.filingStatus && agi >= r.start && (r.end === null || agi <= r.end ))

    if (record) {
      const infYears = taxYear - year
      if (infRate > 0 && infYears > 0) {
        const infRecord: IMedicarePremiumRecord = {
          year: taxYear,
          filingStatus: record.filingStatus,
          start: this.futureValue(record.start, infRate, infYears),
          end: record.end ? this.futureValue(record.end, infRate, infYears) : null,
          amount: this.futureValue(record.amount, infRate, infYears)
        }
        return infRecord
      }
    }

    return record
  }

  getMedicarePremiums(taxYear: number, filingStatus: TaxFilingStatus, infRate: number = 0): IMedicarePremiumRecord[] {
    const year = Math.max(Math.min(taxYear, MaxMedicareYear), MinMedicareYear)
    const records = MedicarePremiumTable.filter(r =>
      year === r.year && filingStatus === r.filingStatus)

    const infYears = taxYear - year

    if (infYears > 0 && infRate > 0 && records.length > 0) {

      const infRecords = new Array<IMedicarePremiumRecord>(records.length)
      for (let ii = 0; ii < records.length; ii++) {
        const record = records[ii]
        infRecords[ii] = {
          year: taxYear,
          filingStatus: record.filingStatus,
          start: this.futureValue(record.start, infRate, infYears),
          end: record.end ? this.futureValue(record.end, infRate, infYears) : null,
          amount: this.futureValue(record.amount, infRate, infYears)
        }
      }
      return infRecords
    }

    return records
  }

  computeTaxLiability(input: TaxInput, estimate: TaxEstimate, taxBracketRecord: any /* TODO */) {

    const qualifiedDividends = input.income.qualifiedDividends
    const shortTermCapitalGains = input.income.unqualifiedCapitalGains
    const longTermCapitalGains = input.income.qualifiedCapitalGains

    if (qualifiedDividends === 0 && shortTermCapitalGains === 0 && longTermCapitalGains === 0) {
      return this.computeTax(input, estimate.taxableIncome, taxBracketRecord, estimate)
    } else {
      // Qualified Dividends and Capital Gain Tax Worksheet 2024 version
      // https://www.irs.gov/pub/irs-pdf/i1040gi.pdf (page 36)
      const line = new Array(26).fill(0)
      line[1] = estimate.taxableIncome
      line[2] = qualifiedDividends
      // Line 16 (total capital Gains) from Schedule D
      const totalCapitalGains = shortTermCapitalGains + longTermCapitalGains
      if (longTermCapitalGains <= 0 || totalCapitalGains <= 0) {
        line[3] = 0
      } else {
        // Smaller of line 15 or 16 from Schedule D
        line[3] = Math.min(longTermCapitalGains, totalCapitalGains)
      }
      line[4] = line[2] + line[3]
      line[5] = Math.max(line[1] - line[4], 0)
      line[6] = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? 94050 : 47025
      line[7] = Math.min(line[1], line[6])
      line[8] = Math.min(line[5], line[7])
      line[9] = line[7] - line[8]
      line[10] = Math.min(line[1], line[4])
      line[11] = line[9]
      line[12] = line[10] - line[11]
      line[13] = (input.filingStatus === TaxFilingStatus.MarriedFilingJointly) ? 583750 : 518900
      line[14] = Math.min(line[1], line[13])
      line[15] = line[5] + line[9]
      line[16] = Math.max(line[14] - line[15], 0)
      line[17] = Math.min(line[12], line[16])
      line[18] = Math.round(line[17] * 0.15)
      line[19] = line[9] + line[17]
      line[20] = line[10] - line[19]
      line[21] = Math.round(line[20] * 0.20)
      line[22] = this.computeTax(input, line[5], undefined, estimate)
      line[23] = line[18] + line[21] + line[22]
      line[24] = this.computeTax(input, line[1])
      line[25] = Math.min(line[23], line[24])

      // this.logLines("Qualified Dividends and Capital Gain Tax Worksheet", line)

      return line[25]
    }
  }

  computeNiit(input: TaxInput, estimate: TaxEstimate) {
    const nii = input.income.taxableInterest + input.income.ordinaryDividends
      + input.income.qualifiedCapitalGains + input.income.unqualifiedCapitalGains
      + input.income.otherIncomeForNiit
    if (nii <= 0) return
    const threshold = input.filingStatus === TaxFilingStatus.MarriedFilingJointly
      ? NiitRules.jointThreshold : NiitRules.singleThreshold
    const magiExcess = estimate.adjustedGrossIncome - threshold
    if (magiExcess <= 0) return
    estimate.netInvestmentIncome = nii
    estimate.niitTax = Math.round(NiitRules.rate * Math.min(nii, magiExcess))
  }

  computeTax(input: TaxInput, taxableIncome: number, taxBracketRecord?: any /* TODO */, taxEstimate?: TaxEstimate) {
    let taxLiability = 0

    if (!taxBracketRecord) {
      taxBracketRecord = this.getTaxBracket(input, taxableIncome)
    }

    if (!taxBracketRecord) {
      return 0
    }

    if (taxEstimate) {
      taxEstimate.taxBracket = taxBracketRecord.bracket
    }

    if (taxBracketRecord.start === 0) {
      taxLiability = taxableIncome * taxBracketRecord.bracket
    } else {
      taxLiability = taxBracketRecord.baseTax + (taxableIncome - taxBracketRecord.start - 1) * taxBracketRecord.bracket
    }

    return Math.round(taxLiability)
  }

  computeDependentTaxCredit(input: TaxInput, estimate: TaxEstimate) {
    // NOTICE: This is from 2020 and no longer used
    return input.childTaxCreditOrCreditForOtherDependents
  }

  computeAdditionalChildTaxCredit(input: TaxInput, estimate: TaxEstimate) {
    // NOTICE: This is from 2020 and no longer used
    return input.refundableAdditionalChildTaxCredits
  }

  logLines(title: string, line: []) {
    console.group(title)
    for (let i=1; i<line.length; i++)
    {
      console.log(i + ": " + line[i])
    }
    console.groupEnd()
  }

  preProcessInputs(input: TaxInput) {
    let income = input.income;

    // If Qualified Dividends is greater than Ordinary Dividends, set Ordinary Dividends equal to Qualified Dividends.
    income.ordinaryDividends = income.qualifiedDividends + income.unqualifiedDividends;
    // income.ordinaryDividends = Math.max(income.ordinaryDividends, income.qualifiedDividends);

    // totalPensionsAndAnnuities is the sum of nonTaxablePensionAndAnnuities and taxablePensionAndAnnuities.
    income.totalPensionsAndAnnuities = income.nonTaxablePensionAndAnnuities + income.taxablePensionAndAnnuities;

    // When Filing Status is Single, numberOfFilersOver65 should max out at 1.
    input.numberOfFilersOver65 = input.filingStatus === TaxFilingStatus.Single
      ? Math.min(1, input.numberOfFilersOver65) : input.numberOfFilersOver65;
  }

  getEffectiveTaxYear(input: TaxInput) {
    if (!input.taxYear) {
      throw new Error("taxYear is required")
    }

    if (input.taxYear < MinTaxYear) {
      return MinTaxYear
    } else if (input.taxYear > MaxTaxYear) {
      return MaxTaxYear
    } else {
      return input.taxYear
    }
  }



}

export const MinTaxYear = 2021
export const MaxTaxYear = 2026
export const MinMedicareYear = 2024
export const MaxMedicareYear = 2026

interface IStandardDeductionRecord {
  filingStatus: number
  taxYear: number
  baseDeduction: number
  over65Deduction: number
}

const StandardDeductionTable: IStandardDeductionRecord[] = [
  {
    "filingStatus": 1,
    "taxYear": 2021,
    "baseDeduction": 12550,
    "over65Deduction": 1700
  },
  {
    "taxYear": 2021,
    "filingStatus": 2,
    "baseDeduction": 25100,
    "over65Deduction": 1350
  },
  {
    "taxYear": 2021,
    "filingStatus": 3,
    "baseDeduction": 12550,
    "over65Deduction": 1350
  },
  {
    "taxYear": 2021,
    "filingStatus": 4,
    "baseDeduction": 18800,
    "over65Deduction": 1700
  },
  {
    "taxYear": 2021,
    "filingStatus": 5,
    "baseDeduction": 25100,
    "over65Deduction": 1350
  },
  {
    "filingStatus": 1,
    "taxYear": 2022,
    "baseDeduction": 12950,
    "over65Deduction": 1750
  },
  {
    "taxYear": 2022,
    "filingStatus": 2,
    "baseDeduction": 25900,
    "over65Deduction": 1400
  },
  {
    "taxYear": 2022,
    "filingStatus": 3,
    "baseDeduction": 12950,
    "over65Deduction": 1400
  },
  {
    "taxYear": 2022,
    "filingStatus": 4,
    "baseDeduction": 19400,
    "over65Deduction": 1750
  },
  {
    "taxYear": 2022,
    "filingStatus": 5,
    "baseDeduction": 25900,
    "over65Deduction": 1400
  },
  /* 2023 */
  {
    "filingStatus": 1,
    "taxYear": 2023,
    "baseDeduction": 13850,
    "over65Deduction": 1850
  },
  {
    "taxYear": 2023,
    "filingStatus": 2,
    "baseDeduction": 27700,
    "over65Deduction": 1500
  },
  {
    "taxYear": 2023,
    "filingStatus": 3,
    "baseDeduction": 13850,
    "over65Deduction": 1500
  },
  {
    "taxYear": 2023,
    "filingStatus": 4,
    "baseDeduction": 19400,
    "over65Deduction": 1850
  },
  {
    "taxYear": 2023,
    "filingStatus": 5,
    "baseDeduction": 27700,
    "over65Deduction": 1500
  },
  /* 2024 */
  {
    "filingStatus": 1,
    "taxYear": 2024,
    "baseDeduction": 14600,
    "over65Deduction": 1950
  },
  {
    "taxYear": 2024,
    "filingStatus": 2,
    "baseDeduction": 29200,
    "over65Deduction": 1550
  },
  {
    "taxYear": 2024,
    "filingStatus": 3,
    "baseDeduction": 14600,
    "over65Deduction": 1550
  },
  {
    "taxYear": 2024,
    "filingStatus": 4,
    "baseDeduction": 21900,
    "over65Deduction": 1950
  },
  {
    "taxYear": 2024,
    "filingStatus": 5,
    "baseDeduction": 29200,
    "over65Deduction": 1550
  },
  /* 2025 */
  {
    "filingStatus": 1,
    "taxYear": 2025,
    "baseDeduction": 15750,
    "over65Deduction": 2000
  },
  {
    "taxYear": 2025,
    "filingStatus": 2,
    "baseDeduction": 31500,
    "over65Deduction": 1600
  },
  {
    "taxYear": 2025,
    "filingStatus": 3,
    "baseDeduction": 15750,
    "over65Deduction": 1600
  },
  {
    "taxYear": 2025,
    "filingStatus": 4,
    "baseDeduction": 23625,
    "over65Deduction": 2000
  },
  {
    "taxYear": 2025,
    "filingStatus": 5,
    "baseDeduction": 31500,
    "over65Deduction": 1600
  },
  /* 2026 */
  {
    "filingStatus": 1,
    "taxYear": 2026,
    "baseDeduction": 16100,
    "over65Deduction": 2050
  },
  {
    "taxYear": 2026,
    "filingStatus": 2,
    "baseDeduction": 32200,
    "over65Deduction": 1650
  },
  {
    "taxYear": 2026,
    "filingStatus": 3,
    "baseDeduction": 16100,
    "over65Deduction": 1650
  },
  {
    "taxYear": 2026,
    "filingStatus": 4,
    "baseDeduction": 24150,
    "over65Deduction": 2050
  },
  {
    "taxYear": 2026,
    "filingStatus": 5,
    "baseDeduction": 32200,
    "over65Deduction": 1650
  }
]

export interface ITaxBracketRecord {
  taxYear: number
  filingStatus: number
  start: number
  end: number | null
  bracket: number
  baseTax: number
}

export const TaxBracketTable: ITaxBracketRecord[] = [
  {
    "taxYear": 2021,
    "filingStatus": 1,
    "start": 0,
    "end": 9950,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2021,
    "filingStatus": 1,
    "start": 9951,
    "end": 40525,
    "bracket": 0.12,
    "baseTax": 995
  },
  {
    "taxYear": 2021,
    "filingStatus": 1,
    "start": 40526,
    "end": 86375,
    "bracket": 0.22,
    "baseTax": 4664
  },
  {
    "taxYear": 2021,
    "filingStatus": 1,
    "start": 86376,
    "end": 164925,
    "bracket": 0.24,
    "baseTax": 14751
  },
  {
    "taxYear": 2021,
    "filingStatus": 1,
    "start": 164926,
    "end": 209425,
    "bracket": 0.32,
    "baseTax": 33603
  },
  {
    "taxYear": 2021,
    "filingStatus": 1,
    "start": 209426,
    "end": 523600,
    "bracket": 0.35,
    "baseTax": 47843
  },
  {
    "taxYear": 2021,
    "filingStatus": 1,
    "start": 523601,
    "end": null,
    "bracket": 0.37,
    "baseTax": 157804.25
  },
  {
    "taxYear": 2021,
    "filingStatus": 2,
    "start": 0,
    "end": 19990,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2021,
    "filingStatus": 2,
    "start": 19991,
    "end": 81050,
    "bracket": 0.12,
    "baseTax": 1999
  },
  {
    "taxYear": 2021,
    "filingStatus": 2,
    "start": 81051,
    "end": 172750,
    "bracket": 0.22,
    "baseTax": 9328
  },
  {
    "taxYear": 2021,
    "filingStatus": 2,
    "start": 172751,
    "end": 329850,
    "bracket": 0.24,
    "baseTax": 29502
  },
  {
    "taxYear": 2021,
    "filingStatus": 2,
    "start": 329851,
    "end": 418850,
    "bracket": 0.32,
    "baseTax": 67206
  },
  {
    "taxYear": 2021,
    "filingStatus": 2,
    "start": 418851,
    "end": 628300,
    "bracket": 0.35,
    "baseTax": 95686
  },
  {
    "taxYear": 2021,
    "filingStatus": 2,
    "start": 628301,
    "end": null,
    "bracket": 0.37,
    "baseTax": 168993.5
  },
  /* 2022 */
  {
    "taxYear": 2022,
    "filingStatus": 1,
    "start": 0,
    "end": 10275,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2022,
    "filingStatus": 1,
    "start": 10276,
    "end": 41775,
    "bracket": 0.12,
    "baseTax": 1027
  },
  {
    "taxYear": 2022,
    "filingStatus": 1,
    "start": 41776,
    "end": 89075,
    "bracket": 0.22,
    "baseTax": 4807
  },
  {
    "taxYear": 2022,
    "filingStatus": 1,
    "start": 89076,
    "end": 170050,
    "bracket": 0.24,
    "baseTax": 15213
  },
  {
    "taxYear": 2022,
    "filingStatus": 1,
    "start": 170051,
    "end": 215950,
    "bracket": 0.32,
    "baseTax": 34647
  },
  {
    "taxYear": 2022,
    "filingStatus": 1,
    "start": 215951,
    "end": 539900,
    "bracket": 0.35,
    "baseTax": 49335
  },
  {
    "taxYear": 2022,
    "filingStatus": 1,
    "start": 539901,
    "end": null,
    "bracket": 0.37,
    "baseTax": 162717
  },
  {
    "taxYear": 2022,
    "filingStatus": 2,
    "start": 0,
    "end": 20550,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2022,
    "filingStatus": 2,
    "start": 20551,
    "end": 83550,
    "bracket": 0.12,
    "baseTax": 2055
  },
  {
    "taxYear": 2022,
    "filingStatus": 2,
    "start": 83551,
    "end": 178150,
    "bracket": 0.22,
    "baseTax": 9615
  },
  {
    "taxYear": 2022,
    "filingStatus": 2,
    "start": 178151,
    "end": 340100,
    "bracket": 0.24,
    "baseTax": 30427
  },
  {
    "taxYear": 2022,
    "filingStatus": 2,
    "start": 340101,
    "end": 431900,
    "bracket": 0.32,
    "baseTax": 69295
  },
  {
    "taxYear": 2022,
    "filingStatus": 2,
    "start": 431901,
    "end": 647850,
    "bracket": 0.35,
    "baseTax": 98671
  },
  {
    "taxYear": 2022,
    "filingStatus": 2,
    "start": 647851,
    "end": null,
    "bracket": 0.37,
    "baseTax": 174253
  },
  /* 2023 */
  {
    "taxYear": 2023,
    "filingStatus": 1,
    "start": 0,
    "end": 11000,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2023,
    "filingStatus": 1,
    "start": 11001,
    "end": 44725,
    "bracket": 0.12,
    "baseTax": 1100
  },
  {
    "taxYear": 2023,
    "filingStatus": 1,
    "start": 44726,
    "end": 95375,
    "bracket": 0.22,
    "baseTax": 5147
  },
  {
    "taxYear": 2023,
    "filingStatus": 1,
    "start": 95376,
    "end": 182100,
    "bracket": 0.24,
    "baseTax": 16290
  },
  {
    "taxYear": 2023,
    "filingStatus": 1,
    "start": 182101,
    "end": 231250,
    "bracket": 0.32,
    "baseTax": 37104
  },
  {
    "taxYear": 2023,
    "filingStatus": 1,
    "start": 231251,
    "end": 578125,
    "bracket": 0.35,
    "baseTax": 52832
  },
  {
    "taxYear": 2023,
    "filingStatus": 1,
    "start": 578126,
    "end": null,
    "bracket": 0.37,
    "baseTax": 174238
  },
  {
    "taxYear": 2023,
    "filingStatus": 2,
    "start": 0,
    "end": 22000,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2023,
    "filingStatus": 2,
    "start": 22001,
    "end": 89450,
    "bracket": 0.12,
    "baseTax": 2200
  },
  {
    "taxYear": 2023,
    "filingStatus": 2,
    "start": 89451,
    "end": 190750,
    "bracket": 0.22,
    "baseTax": 10294
  },
  {
    "taxYear": 2023,
    "filingStatus": 2,
    "start": 190751,
    "end": 364200,
    "bracket": 0.24,
    "baseTax": 32580
  },
  {
    "taxYear": 2023,
    "filingStatus": 2,
    "start": 364201,
    "end": 462500,
    "bracket": 0.32,
    "baseTax": 74208
  },
  {
    "taxYear": 2023,
    "filingStatus": 2,
    "start": 462501,
    "end": 693750,
    "bracket": 0.35,
    "baseTax": 105664
  },
  {
    "taxYear": 2023,
    "filingStatus": 2,
    "start": 693751,
    "end": null,
    "bracket": 0.37,
    "baseTax": 186601
  },
  /* 2024 */
  {
    "taxYear": 2024,
    "filingStatus": 1,
    "start": 0,
    "end": 11600,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2024,
    "filingStatus": 1,
    "start": 11601,
    "end": 47150,
    "bracket": 0.12,
    "baseTax": 1160
  },
  {
    "taxYear": 2024,
    "filingStatus": 1,
    "start": 47151,
    "end": 100525,
    "bracket": 0.22,
    "baseTax": 5426 // (47150-11601) * .12 + 1160
  },
  {
    "taxYear": 2024,
    "filingStatus": 1,
    "start": 100526,
    "end": 191950,
    "bracket": 0.24,
    "baseTax": 17168 // (100525-47151) * .22 + 5426
  },
  {
    "taxYear": 2024,
    "filingStatus": 1,
    "start": 191951,
    "end": 243725,
    "bracket": 0.32,
    "baseTax": 39110 // (191950-100526) * .24 + 17168
  },
  {
    "taxYear": 2024,
    "filingStatus": 1,
    "start": 243726,
    "end": 609350,
    "bracket": 0.35,
    "baseTax": 55678 // (243725-191951) * .32 + 39110
  },
  {
    "taxYear": 2024,
    "filingStatus": 1,
    "start": 609351,
    "end": null,
    "bracket": 0.37,
    "baseTax": 183646 // (609350-243726) * .35 + 55678
  },
  {
    "taxYear": 2024,
    "filingStatus": 2,
    "start": 0,
    "end": 23200,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2024,
    "filingStatus": 2,
    "start": 23201,
    "end": 94300,
    "bracket": 0.12,
    "baseTax": 2320 // (23200-0) * 0.10 + 0
  },
  {
    "taxYear": 2024,
    "filingStatus": 2,
    "start": 94301,
    "end": 201050,
    "bracket": 0.22,
    "baseTax": 10852 // (94300-23201) *.12 + 2320
  },
  {
    "taxYear": 2024,
    "filingStatus": 2,
    "start": 201051,
    "end": 383900,
    "bracket": 0.24,
    "baseTax": 34337 // (201050-94301) * .22 + 10852
  },
  {
    "taxYear": 2024,
    "filingStatus": 2,
    "start": 383901,
    "end": 487450,
    "bracket": 0.32,
    "baseTax": 78220 // (383900-201051) * .24 + 34337
  },
  {
    "taxYear": 2024,
    "filingStatus": 2,
    "start": 487451,
    "end": 731200,
    "bracket": 0.35,
    "baseTax": 111356 // (487450-383901) * .32 + 78221
  },
  {
    "taxYear": 2024,
    "filingStatus": 2,
    "start": 731201,
    "end": null,
    "bracket": 0.37,
    "baseTax": 196668 // (731200-487451) * .35 + 111357
  },
  /* 2025 */
  {
    "taxYear": 2025,
    "filingStatus": 1,
    "start": 0,
    "end": 11925,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2025,
    "filingStatus": 1,
    "start": 11926,
    "end": 48475,
    "bracket": 0.12,
    "baseTax": 1193
  },
  {
    "taxYear": 2025,
    "filingStatus": 1,
    "start": 48476,
    "end": 103350,
    "bracket": 0.22,
    "baseTax": 5578
  },
  {
    "taxYear": 2025,
    "filingStatus": 1,
    "start": 103351,
    "end": 197300,
    "bracket": 0.24,
    "baseTax": 17651
  },
  {
    "taxYear": 2025,
    "filingStatus": 1,
    "start": 197301,
    "end": 250525,
    "bracket": 0.32,
    "baseTax": 40198
  },
  {
    "taxYear": 2025,
    "filingStatus": 1,
    "start": 250526,
    "end": 626350,
    "bracket": 0.35,
    "baseTax": 57230
  },
  {
    "taxYear": 2025,
    "filingStatus": 1,
    "start": 626351,
    "end": null,
    "bracket": 0.37,
    "baseTax": 188769
  },
  {
    "taxYear": 2025,
    "filingStatus": 2,
    "start": 0,
    "end": 23850,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2025,
    "filingStatus": 2,
    "start": 23851,
    "end": 96950,
    "bracket": 0.12,
    "baseTax": 2385
  },
  {
    "taxYear": 2025,
    "filingStatus": 2,
    "start": 96951,
    "end": 206700,
    "bracket": 0.22,
    "baseTax": 11157
  },
  {
    "taxYear": 2025,
    "filingStatus": 2,
    "start": 206701,
    "end": 394600,
    "bracket": 0.24,
    "baseTax": 35302
  },
  {
    "taxYear": 2025,
    "filingStatus": 2,
    "start": 394601,
    "end": 501050,
    "bracket": 0.32,
    "baseTax": 80397
  },
  {
    "taxYear": 2025,
    "filingStatus": 2,
    "start": 501051,
    "end": 751600,
    "bracket": 0.35,
    "baseTax": 114461
  },
  {
    "taxYear": 2025,
    "filingStatus": 2,
    "start": 751601,
    "end": null,
    "bracket": 0.37,
    "baseTax": 202153
  },
  /* 2026 */
  {
    "taxYear": 2026,
    "filingStatus": 1,
    "start": 0,
    "end": 12400,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2026,
    "filingStatus": 1,
    "start": 12401,
    "end": 50400,
    "bracket": 0.12,
    "baseTax": 1240
  },
  {
    "taxYear": 2026,
    "filingStatus": 1,
    "start": 50401,
    "end": 105700,
    "bracket": 0.22,
    "baseTax": 5800
  },
  {
    "taxYear": 2026,
    "filingStatus": 1,
    "start": 105701,
    "end": 201775,
    "bracket": 0.24,
    "baseTax": 17966
  },
  {
    "taxYear": 2026,
    "filingStatus": 1,
    "start": 201776,
    "end": 256225,
    "bracket": 0.32,
    "baseTax": 41023
  },
  {
    "taxYear": 2026,
    "filingStatus": 1,
    "start": 256226,
    "end": 640600,
    "bracket": 0.35,
    "baseTax": 58447
  },
  {
    "taxYear": 2026,
    "filingStatus": 1,
    "start": 640601,
    "end": null,
    "bracket": 0.37,
    "baseTax": 192978
  },
  {
    "taxYear": 2026,
    "filingStatus": 2,
    "start": 0,
    "end": 24800,
    "bracket": 0.10,
    "baseTax": 0
  },
  {
    "taxYear": 2026,
    "filingStatus": 2,
    "start": 24801,
    "end": 100800,
    "bracket": 0.12,
    "baseTax": 2480
  },
  {
    "taxYear": 2026,
    "filingStatus": 2,
    "start": 100801,
    "end": 211400,
    "bracket": 0.22,
    "baseTax": 11600
  },
  {
    "taxYear": 2026,
    "filingStatus": 2,
    "start": 211401,
    "end": 403550,
    "bracket": 0.24,
    "baseTax": 35932
  },
  {
    "taxYear": 2026,
    "filingStatus": 2,
    "start": 403551,
    "end": 512450,
    "bracket": 0.32,
    "baseTax": 82047
  },
  {
    "taxYear": 2026,
    "filingStatus": 2,
    "start": 512451,
    "end": 768700,
    "bracket": 0.35,
    "baseTax": 116895
  },
  {
    "taxYear": 2026,
    "filingStatus": 2,
    "start": 768701,
    "end": null,
    "bracket": 0.37,
    "baseTax": 206582
  }
]

export interface IMedicarePremiumRecord {
  year: number
  filingStatus: number
  start: number
  end: number | null
  amount: number
}

export const MedicarePremiumTable: IMedicarePremiumRecord[] = [
  /* 2024 */
  {
    "year": 2024,
    "filingStatus": 1,
    "start": 0,
    "end": 103000,
    "amount": 175
  },
  {
    "year": 2024,
    "filingStatus": 1,
    "start": 103001,
    "end": 129000,
    "amount": 245
  },
  {
    "year": 2024,
    "filingStatus": 1,
    "start": 129001,
    "end": 161000,
    "amount": 349
  },
  {
    "year": 2024,
    "filingStatus": 1,
    "start": 161001,
    "end": 193000,
    "amount": 454
  },
  {
    "year": 2024,
    "filingStatus": 1,
    "start": 193001,
    "end": 499999,
    "amount": 559
  },
  {
    "year": 2024,
    "filingStatus": 1,
    "start": 500000,
    "end": null,
    "amount": 594
  },

  {
    "year": 2024,
    "filingStatus": 2,
    "start": 0,
    "end": 206000,
    "amount": 175
  },
  {
    "year": 2024,
    "filingStatus": 2,
    "start": 206001,
    "end": 258000,
    "amount": 245
  },
  {
    "year": 2024,
    "filingStatus": 2,
    "start": 258001,
    "end": 322000,
    "amount": 349
  },
  {
    "year": 2024,
    "filingStatus": 2,
    "start": 322001,
    "end": 386000,
    "amount": 454
  },
  {
    "year": 2024,
    "filingStatus": 2,
    "start": 386001,
    "end": 749999,
    "amount": 559
  },
  {
    "year": 2024,
    "filingStatus": 2,
    "start": 750000,
    "end": null,
    "amount": 594
  },
  /* 2025 */
  {
    "year": 2025,
    "filingStatus": 1,
    "start": 0,
    "end": 106000,
    "amount": 185
  },
  {
    "year": 2025,
    "filingStatus": 1,
    "start": 106001,
    "end": 133000,
    "amount": 259
  },
  {
    "year": 2025,
    "filingStatus": 1,
    "start": 133001,
    "end": 167000,
    "amount": 370
  },
  {
    "year": 2025,
    "filingStatus": 1,
    "start": 167001,
    "end": 200000,
    "amount": 480.90
  },
  {
    "year": 2025,
    "filingStatus": 1,
    "start": 200001,
    "end": 499999,
    "amount": 591.90
  },
  {
    "year": 2025,
    "filingStatus": 1,
    "start": 500000,
    "end": null,
    "amount": 628.90
  },

  {
    "year": 2025,
    "filingStatus": 2,
    "start": 0,
    "end": 212000,
    "amount": 185
  },
  {
    "year": 2025,
    "filingStatus": 2,
    "start": 212001,
    "end": 266000,
    "amount": 259
  },
  {
    "year": 2025,
    "filingStatus": 2,
    "start": 266001,
    "end": 334000,
    "amount": 370
  },
  {
    "year": 2025,
    "filingStatus": 2,
    "start": 334001,
    "end": 400000,
    "amount": 480.90
  },
  {
    "year": 2025,
    "filingStatus": 2,
    "start": 400001,
    "end": 749999,
    "amount": 591.90
  },
  {
    "year": 2025,
    "filingStatus": 2,
    "start": 750000,
    "end": null,
    "amount": 628.90
  },
  /* 2026 */
  {
    "year": 2026,
    "filingStatus": 1,
    "start": 0,
    "end": 109000,
    "amount": 202.9
  },
  {
    "year": 2026,
    "filingStatus": 1,
    "start": 109001,
    "end": 137000,
    "amount": 284.1
  },
  {
    "year": 2026,
    "filingStatus": 1,
    "start": 137001,
    "end": 171000,
    "amount": 405.8
  },
  {
    "year": 2026,
    "filingStatus": 1,
    "start": 171001,
    "end": 205000,
    "amount": 527.50
  },
  {
    "year": 2026,
    "filingStatus": 1,
    "start": 205001,
    "end": 499999,
    "amount": 649.20
  },
  {
    "year": 2026,
    "filingStatus": 1,
    "start": 500000,
    "end": null,
    "amount": 689.90
  },

  {
    "year": 2026,
    "filingStatus": 2,
    "start": 0,
    "end": 218000,
    "amount": 202.90
  },
  {
    "year": 2026,
    "filingStatus": 2,
    "start": 218001,
    "end": 274000,
    "amount": 284.10
  },
  {
    "year": 2026,
    "filingStatus": 2,
    "start": 274001,
    "end": 342000,
    "amount": 405.80
  },
  {
    "year": 2026,
    "filingStatus": 2,
    "start": 342001,
    "end": 410000,
    "amount": 527.50
  },
  {
    "year": 2026,
    "filingStatus": 2,
    "start": 410001,
    "end": 749999,
    "amount": 649.20
  },
  {
    "year": 2026,
    "filingStatus": 2,
    "start": 750000,
    "end": null,
    "amount": 689.9
  },
]

export const StateRates = {
  '': 0,
  'AL': 3.5,
  'AK': 0,
  'AZ': 2.5,
  'AR': 4,
  'CA': 4.9,
  'CO': 4.55,
  'CT': 5.5,
  'DC': 6,
  'DE': 5.5,
  'FL': 0,
  'GA': 4,
  'HI': 5.8,
  'ID': 5.8,
  'IL': 4.95,
  'IN': 3.23,
  'IA': 4,
  'KS': 4,
  'KY': 4,
  'LA': 3,
  'ME': 6,
  'MD': 5.75,
  'MA': 5,
  'MI': 4.25,
  'MN': 6,
  'MS': 4,
  'MO': 4,
  'MT': 5.9,
  'NE': 4.5,
  'NV': 0,
  'NH': 0,
  'NJ': 5.8,
  'NM': 4.9,
  'NY': 5.8,
  'NC': 4.5,
  'ND': 2.9,
  'OH': 3.5,
  'OK': 4,
  'OR': 6,
  'PA': 3.07,
  'PR': 0,
  'RI': 5.5,
  'SC': 4,
  'SD': 0,
  'TN': 0,
  'TX': 0,
  'UT': 4.85,
  'VT': 5.8,
  'VA': 5,
  'WA': 0,
  'WI': 4,
  'WV': 4,
  'WY': 0
}

export default TaxEstimator
// Only for testing (nodejs)
// if (typeof window === 'undefined') {
//   module.exports = {
//     TaxFilingStatus : TaxFilingStatus,
//     TaxInput : TaxInput,
//     TaxEstimate: TaxEstimate,
//     TaxEstimator : TaxEstimator
//   }
// }